<template>
  <div
    class="DesktopMenuContent bg-lightest border-r border-light type-sm relative select-none"
    :class="{
      animateIn: depth > 0
    }"
  >
    <!-- * * * * * * head -->
    <div v-if="depth > 0" class="type-headline-lg pl-20 pt-20">
      {{ menuName }}
    </div>

    <div
      class="py-8 pr-8"
      :class="{
        'pl-8': depth > 0
      }"
    >
      <!-- * * * * * * primary menu -->
      <div
        v-if="parentMenu?.mobileButton && parentMenu?.link && parentMenu.mobileButton !== ''"
        class="w-[calc(100% - 24px)] -ml-12"
      >
        <nuxt-link
          :to="$sbLinkFix(parentMenu?.link)"
          :target="$sbLinkTarget(parentMenu?.link)"
          class="DeskNav"
        >
          {{ parentMenu?.mobileButton }}
        </nuxt-link>
      </div>
      <div class="first:-ml-0 even:-ml-12">
        <div
          v-for="link in content"
          :key="link._uid"
          class="DeskNav"
          :class="{
            'text-text-errorStrong': checkDesign(link.design, 'sale'),
            'selected': uiStore.isParentOfOpenMenu(link._uid),
          }"
          @click="clickMenu($sbLinkFix(link.link), (link.children.length > 0), link._uid)"
        >
          <div v-if="link.icon && link.icon.filename" class="basis-24">
            <img
              :src="link.icon.filename"
              class="w-24 h-24"
              :alt="link.title"
            >
          </div>
          <div
            class="basis-full"
            :class="{
              'pl-12': link.icon?.filename
            }"
          >
            {{ link.title }}
          </div>
          <MenuItemFavorite
            v-if="!userStore.isCustomerSuccessUser"
            :item="link"
            :hide-title="true"
          />
          <div v-if="link.children.length" class="basis-24">
            <GlobalIcon name="angle-right" size="small" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalContentStore } from '~/store/globalContent';
import { StoryBlokNestableNav } from '~/constants/types/storyblok';
import { useUiStore } from '~/store/ui';
import { useUserStore } from '~/store/user';
import useMenuHelper from '~/composeables/useMenuHelper';
import MenuItemFavorite from '~/components/menu/MenuItemFavorite.vue';
const uiStore = useUiStore();
const userStore = useUserStore();
const globalContent = useGlobalContentStore();

const props = defineProps<{
  parent: string,
  depth: number,
}>();

let content = [] as StoryBlokNestableNav[];
let menuName = 'Menu';

let parentMenu = null as StoryBlokNestableNav | null;

const submenu = globalContent.getNavByUid(props.parent, 'main');
if (submenu) {
  parentMenu = submenu;
  content = submenu.children;
  menuName = submenu.title;
}

const router = useRouter();
const clickMenu = (url: string | null, children: boolean | null, _uid: string) => {
  if (children || _uid === 'selectCountry') {
    uiStore.addSideMenuParent(_uid, props.parent);
  } else {
    router.push({ path: `${url}` });
    uiStore.closeDesktopMenu();
  }
};

const { checkDesign } = useMenuHelper();

</script>

<style scoped lang="postcss">
.DeskNav {
  @apply w-full h-40 pl-12 pr-8 flex items-center justify-between text-text-subtle leading-single rounded-2 transition-all cursor-pointer;

  &.selected {
    @apply bg-bg-brandSubtle text-text-base cursor-default;
  }

  &:hover:not(.selected) {
    @apply bg-bg-brandSubtle  text-text-base;
  }
}
.animateIn {
  animation: .0s ease-out 0s 1 SlideIn;
}
@keyframes SlideIn {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(-0%);
  }
}
</style>
